import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (e2) {
      toast.error(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-24">
      <h1 className="font-serif text-4xl font-bold">Shop owner login</h1>
      <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
        <input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full rounded-xl border border-[#E2D7C3] bg-white px-4 py-3" data-testid="admin-email-input" />
        <input required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full rounded-xl border border-[#E2D7C3] bg-white px-4 py-3" data-testid="admin-password-input" />
        <button disabled={busy} className="w-full rounded-full bg-[#0F172A] text-white py-3.5 font-semibold disabled:opacity-60" data-testid="admin-login-submit">{busy ? "Signing in…" : "Sign in"}</button>
      </form>
    </div>
  );
}
